import { Grid } from "@mui/material";

import { SearchWithFilters } from "@dzambalaorg/mui-form-search";
import { EthInput } from "@dzambalaorg/mui-inputs-mask";
import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { ModuleType, TokenType, ILootBoxSearchDto } from "@framework/types";

interface ILootboxSearchFormProps {
  initialValues: Partial<ILootBoxSearchDto>;
  embedded?: boolean;
}

export const LootBoxSearchForm = (props: ILootboxSearchFormProps) => {
  const { initialValues, embedded } = props;

  return (
    <SearchWithFilters initialValues={initialValues}>
      <Grid container spacing={2} alignItems="flex-end">
        <Grid size={{ xs: 6 }}>
          <EthInput name="minPrice" />
        </Grid>
        <Grid size={{ xs: 6 }}>
          <EthInput name="maxPrice" />
        </Grid>
        {!embedded ? (
          <Grid size={{ xs: 12 }}>
            <EntityInput
              name="contractIds"
              controller="contracts"
              multiple
              fetchData={{
                contractType: [TokenType.ERC721],
                contractModule: [ModuleType.LOOT],
              }}
            />
          </Grid>
        ) : null}
      </Grid>
    </SearchWithFilters>
  );
};
